// hooks/useMoreLinks.ts — hook for the More hub page data.
//
// More hub data is static in the prototype, so no Zustand store is needed.
// Returns the seed data directly. When a live API is introduced (B4),
// this will read from a store.
// Components must NOT import moreService or seedMoreGroups directly.

import { seedMoreGroups, seedQuickToggles } from '@/core/data/more-links';
import type { MoreGroup, QuickToggle } from '@/core/models/more';

export interface MoreLinksHook {
  /** All More hub groups. */
  groups: MoreGroup[];
  /** Quick-toggle items (footer). */
  quickToggles: QuickToggle[];
}

/** Returns the static More hub page data. */
export function useMoreLinks(): MoreLinksHook {
  return {
    groups: seedMoreGroups,
    quickToggles: seedQuickToggles,
  };
}
